import { useEffect } from "react";
import { t } from "../i18n/t";

/** Set `document.title` to "<title> – Skoleveianalyse". */
export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    const app = t("app.name");
    document.title = title ? `${title} – ${app}` : app;
  }, [title]);
}
